(() => {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const body = document.body;
  const header = qs('[data-header]');
  const drawer = qs('[data-menu-drawer]');
  const searchPanel = qs('[data-search-panel]');

  const closePanels = () => {
    body.classList.remove('menu-open', 'search-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (searchPanel) searchPanel.setAttribute('aria-hidden', 'true');
  };

  qsa('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
    const open = !body.classList.contains('menu-open');
    closePanels();
    if (open && drawer) {
      body.classList.add('menu-open');
      drawer.setAttribute('aria-hidden', 'false');
      const firstLink = qs('a', drawer);
      if (firstLink) firstLink.focus();
    }
  }));

  qsa('[data-search-toggle]').forEach((button) => button.addEventListener('click', () => {
    const open = !body.classList.contains('search-open');
    closePanels();
    if (open && searchPanel) {
      body.classList.add('search-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      const input = qs('input', searchPanel);
      if (input) input.focus();
    }
  }));

  qsa('[data-panel-close]').forEach((button) => button.addEventListener('click', closePanels));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closePanels(); });

  if (header) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 12);
      header.classList.toggle('is-hidden', y > 140 && y > lastY && !body.classList.contains('menu-open'));
      lastY = y;
    }, { passive: true });
  }

  qsa('[data-carousel]').forEach((carousel) => {
    const track = qs('[data-carousel-track]', carousel);
    if (!track) return;
    const controls = qsa('[data-carousel-next], [data-carousel-prev]', carousel);
    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const previous = qs('[data-carousel-prev]', carousel);
      const next = qs('[data-carousel-next]', carousel);
      if (previous) previous.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    };
    controls.forEach((button) => button.addEventListener('click', () => {
      const direction = button.hasAttribute('data-carousel-next') ? 1 : -1;
      const step = carousel.dataset.carouselStep === 'page'
        ? track.clientWidth
        : Math.max(track.clientWidth * 0.8, 280);
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  });

  qsa('[data-product-gallery]').forEach((gallery) => {
    const featured = qs('.product-gallery__item--featured', gallery);
    const mainImage = qs('[data-gallery-main]', gallery);
    const thumbnails = qsa('[data-gallery-thumb]', gallery);
    const previous = qs('[data-gallery-prev]', gallery);
    const next = qs('[data-gallery-next]', gallery);
    if (!featured || !mainImage || (!previous && !next)) return;

    // The first thumbnail is the featured image too. Build the list from the
    // thumbnails only so the active underline and displayed image stay aligned.
    const items = thumbnails.length
      ? thumbnails.map((thumbnail) => ({ url: thumbnail.dataset.galleryUrl, alt: thumbnail.dataset.galleryAlt }))
      : [{ url: mainImage.currentSrc || mainImage.src, alt: mainImage.alt }];
    let activeIndex = 0;

    if (items.length < 2) {
      if (previous) previous.hidden = true;
      if (next) next.hidden = true;
    }

    const setActive = (index) => {
      activeIndex = (index + items.length) % items.length;
      const item = items[activeIndex];
      if (!item || !item.url) return;
      mainImage.classList.add('is-changing');
      const revealImage = () => {
        requestAnimationFrame(() => mainImage.classList.remove('is-changing'));
      };
      mainImage.addEventListener('load', revealImage, { once: true });
      mainImage.src = item.url;
      mainImage.alt = item.alt || mainImage.alt;
      if (mainImage.complete) window.setTimeout(revealImage, 180);
      thumbnails.forEach((thumbnail) => thumbnail.classList.toggle('is-active', Number(thumbnail.dataset.galleryIndex) === activeIndex));
    };

    if (previous) previous.addEventListener('click', () => setActive(activeIndex - 1));
    if (next) next.addEventListener('click', () => setActive(activeIndex + 1));
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => setActive(Number(thumbnail.dataset.galleryIndex))));

    const showEdgeArrow = (clientX) => {
      const bounds = featured.getBoundingClientRect();
      const localX = clientX - bounds.left;
      const edgeSize = Math.min(92, bounds.width * .2);
      if (previous) previous.classList.toggle('is-visible', localX <= edgeSize && items.length > 1);
      if (next) next.classList.toggle('is-visible', localX >= bounds.width - edgeSize && items.length > 1);
    };
    const hideEdgeArrows = () => {
      if (previous) previous.classList.remove('is-visible');
      if (next) next.classList.remove('is-visible');
    };

    featured.addEventListener('pointermove', (event) => showEdgeArrow(event.clientX));
    featured.addEventListener('pointerleave', hideEdgeArrows);
    featured.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (touch) showEdgeArrow(touch.clientX);
    }, { passive: true });
  });

  qsa('[data-accordion-trigger]').forEach((trigger) => trigger.addEventListener('click', () => {
    const item = trigger.closest('[data-accordion-item]');
    const panel = qs('[data-accordion-panel]', item);
    const open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
    item.classList.toggle('is-open', !open);
    if (panel) panel.hidden = open;
  }));

  const trackForm = qs('[data-track-form]');
  if (trackForm) trackForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const number = qs('input', trackForm).value.trim();
    const result = qs('[data-track-result]');
    if (!number) return;
    if (result) {
      result.hidden = false;
      result.textContent = `${number} izləmə nömrəsi qəbul edildi. Açılışdan əvvəl bu formanı daşıyıcı və ya sifariş izləmə tətbiqinə bağla.`;
    }
  });
})();
